import Product from "./Product";

class AmazingProductsRow{
    constructor(json){
        this.store_name=json.store_name;
        this.products = [];
        json.products.forEach((product)=>{
            this.products.push(new Product(product));
        });
    }
}

export default AmazingProductsRow;